import { defineComponent, openBlock, createElementBlock, normalizeStyle, normalizeClass } from 'vue';

var script = defineComponent({
    name: 'Skeleton',
    props: {
        prefix: { type: String, default: '' },
        width: { type: String, default: '100%' },
        height: { type: String, default: '' }
    }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", {
    style: normalizeStyle({width: _ctx.width, height: _ctx.height}),
    class: normalizeClass(`${_ctx.prefix}skeleton`)
  }, null, 6 /* CLASS, STYLE */))
}

script.render = render;
script.__file = "packages/vue/skeleton/lib/Skeleton.vue";

export { script as default };
